export default __webpack_public_path__ + "static/media/example_company_1.7ea4e558.webp";